/**
 * WikiTree ID helpers. A WikiTree ID is "Surname-Number" — e.g. Brown-7,
 * O'Brien-12, Van_Buren-3 (spaces in surnames appear as underscores in URLs).
 */

/** Shape of a WikiTree ID. Rejects numeric REFNs and anything with whitespace. */
export const WIKITREE_ID_RE = /^[^\s\d-][^\s]*-\d+$/;

/** WikiTree profile URL in a GEDCOM `WWW` line; group 1 is the URL-encoded ID. */
export const WIKITREE_WWW_RE = /wikitree\.com\/wiki\/([^\s/?#]+)/i;

export function isWikiTreeId(value: string | undefined): value is string {
  return value !== undefined && WIKITREE_ID_RE.test(value);
}

/** Comparison key: trimmed, case-insensitive, "_" ≡ " " (Van Buren-3 ≡ Van_Buren-3). */
export function wikiTreeIdKey(id: string): string {
  return id.trim().toLowerCase().replace(/_/g, ' ');
}

/** Profile URL for a validated ID. The ID is URI-encoded; the origin is fixed. */
export function wikiTreeUrl(id: string): string {
  return `https://www.wikitree.com/wiki/${encodeURIComponent(id)}`;
}
